import { css } from 'styled-components';
import { TypographyName, getTypography, getSpacing, SpacingName } from '../../theme';
export const modalHeader = _ref => {
  let {
    theme,
    $padded,
    $hasClose
  } = _ref;
  const padding = $padded ? [SpacingName.SMALL, $hasClose ? SpacingName.BIGGER : SpacingName.MEDIUM, SpacingName.SMALL, SpacingName.MEDIUM] : [0, $hasClose ? SpacingName.BIGGER : 0, 0, 0];
  return css(["", " background-color:", ";"], getSpacing.padding(theme, padding), theme.palettes.neutrals.lightest);
};
export const modalHeaderTitle = _ref2 => {
  let {
    theme
  } = _ref2;
  return css(["", ""], getTypography(theme, TypographyName.H3));
};
//# sourceMappingURL=ModalHeader.style.js.map